<template>
  <div class="explain">
    <template v-for="(item,index) in dataList">
      <div class="item-box" :key="index">
        <div class="item-title">{{item.title}}</div>
        <div class="item-text" v-if="Array.isArray(item.text)" >
          <div class="item-text" v-for="(child,cindex) in item.text" :key="cindex">{{child}}</div>
        </div>
        <div class="item-text" v-else>{{item.text}}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  data(){
    return {
      dataList:[
        {title:'适用人群：',text:'湖南省医保参保人专属(含城镇职工、城乡居民)'},
        {title:'参保时间：',text:'2021年10月9日-11月30日'},
        {title:'保障期限：',text:'202x年xx月xx日-2022年xx月xx日'},
        {title:'承保单位：',text:['中国人寿保险股份有限公司', '中国人寿财产保险股份有限公司', '平安养老保险股份有限公司', '中国太平洋财产保险股份有限公司']},
      ]
    }
  },
}
</script>
<style lang="scss">
  .explain{
    position: relative;
    top: xvh(-34);
    width: xvw(690);
    background: #ffffff;
    box-shadow: 0px 0px 30px 0px rgba(228, 36, 36, 0.15);
    border-radius: 20px;
    padding: xvw(24) xvw(30);
    .item-box{
      display: flex;
      .item-title{
        font-size: xvw(24);
        font-weight: 700;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        color: #525252;
        line-height: xvw(42);
        flex-shrink: 0;
      }
      .item-text{
        font-size: xvw(24);
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #7D7D7D;
        line-height: xvw(42);
      }
    }
  }
</style>